import { type FlexProps, Link } from '@chakra-ui/react';
import { TokenSelector } from '@ui/components/Input/TokenSelector';
import { MaskIcon } from '@ui/components/MaskIcon';
import { useTokenSelectDialog } from '@ui/components/TokenSelectDialog/useTokenSelectDialog';
import { EXTERNAL_LINK } from '@ui/config/externalLinks';
import { Token } from '@ui/config/token';
import type { NormalToken } from '@ui/config/token/types';
import { isNormalToken } from '@ui/config/token/types';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';

export interface NormalTokenSelectorProps extends FlexProps {
  isSelectable?: boolean;
  fromToken: Token;
  toToken: Token;
  onSelectToken: (newToken: Token) => void;
  tokenList?: NormalToken[];
}

export const NormalTokenSelector = ({
  isSelectable = true,
  fromToken,
  toToken,
  onSelectToken,
  tokenList,
  ...props
}: NormalTokenSelectorProps) => {
  const chainLayer = useGlobalChainLayer();
  const normalToken = isNormalToken(fromToken) ? fromToken : toToken;

  return (
    <TokenSelector
      token={normalToken}
      onClick={
        isSelectable
          ? () => {
              useTokenSelectDialog.getState().open({
                onSelectToken,
                tokenList,
              });
            }
          : undefined
      }
      footer={
        normalToken === Token.agentFun && (
          <Link
            href={EXTERNAL_LINK.swapAgentFun(chainLayer)}
            target="_blank"
            color="currentcolor"
            gap="0"
          >
            Buy AGENTFUN
            <MaskIcon
              display="inline-block"
              icon="url(/masks/arrow-outward.svg)"
              boxSize="16px"
              bgColor="currentcolor"
            />
          </Link>
        )
      }
      {...props}
    />
  );
};
